window.SubscriptionFunnel.StepAllergies = {
  validateAllergies() {
    const selectedOptions = document.querySelectorAll(
      `#select-allergies input:checked`
    );

    if (!selectedOptions || selectedOptions.length === 0) {
      const errorMessage = document.querySelector(`#select-allergies .form-input-text-error-message`);
      if (errorMessage) {
        errorMessage.classList.remove("display-none");
      }
      document
        .querySelectorAll("#select-allergies .checkbox-multi-component-inner")
        .forEach((el) => {
          el.classList.add("checkbox-multi-component-error");
        });
      return false;
    }

    // Build a Set of selected option names in a single iteration
    const selectedNames = new Set();
    Array.from(selectedOptions).forEach((option) => {
      selectedNames.add(option.name);
    });

    const noExclusionsSelected = selectedNames.has("subscription_allergy_selection[no_exclusions]");

    // Use ternary operators to set values directly
    quizData.allergies = !noExclusionsSelected;
    quizData.allergiesChicken = noExclusionsSelected ? false : selectedNames.has("subscription_allergy_selection[chicken]");
    quizData.allergiesTurkey = noExclusionsSelected ? false : selectedNames.has("subscription_allergy_selection[turkey]");
    quizData.allergiesBeef = noExclusionsSelected ? false : selectedNames.has("subscription_allergy_selection[beef]");
    SubscriptionFunnel.FunnelNavigation.nextStep();
  },

  handleAllergySelect(event) {
    document
      .querySelector(`#select-allergies .form-input-text-error-message`)
      .classList.add("display-none");
    document
      .querySelectorAll("#select-allergies .checkbox-multi-component-inner")
      .forEach((el) => {
        el.classList.remove("checkbox-multi-component-error");
      });
    const { name, checked } = event.target;
    if (name === "subscription_allergy_selection[no_exclusions]" && checked) {
      document
        .querySelectorAll("#select-allergies input:not(#allergy-none)")
        .forEach((el) => {
          el.checked = false;
        });
    } else if (checked) {
      document.querySelector(
        "#select-allergies input#allergy-none"
      ).checked = false;
    }
  },
};
